import { render, staticRenderFns } from "./EventDetailModalPanel.vue?vue&type=template&id=2e4569f4"
import script from "./EventDetailModalPanel.vue?vue&type=script&lang=js"
export * from "./EventDetailModalPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports